export default "__VITE_ASSET__4866f9c1__"